import React, { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ProductFlag } from "@tw/shared-ui-components/lib/components/productFlag/productFlag";
import Heart from "./images/heart.png";
import styles from "./productGallery.scss";
import "./slick.css";
import { Modal } from "./modal/modal.jsx";
import ProductSlider from "./productSlider/productSlider";
import { addToWishlist, removeToWishlist } from "../../../common/utils/apis";
import { UserRoles } from "../../../common/constant";
import { getLoggedInUserInfo } from "../../../common/utils/helper";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";
import PlpModal from "../../../common/components/modal/modal";
import PlpBottomDrawer from "../../../common/components/plpBottomDrawer/plpBottomDrawer";
import Breakpoint from "@tw/style-guide/lib/components/utilities/breakpoint";
import { saveAs } from "file-saver";
//import ShareBar from "@tw/shared-ui-components/lib/components/shareBar/shareBar";

function ProductGallery(props) {
  const {
    gallery,
    labels,
    productCode,
    itemCode,
    isCollected,
    showIcons,
    disableAddToCollection,
  } = props;
  const [toggle, setToggle] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isAddedWishlist, setIsAddedWishlist] = useState(isCollected);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [breakpoint, setBreakpoint] = useState("xs");
  //const [selectedShareId, setShareId] = useState();
  //const [showPopupShare, setShowPopupShare] = useState(false);

  const LoggedInUserRole = getLoggedInUserInfo().role;

  // const handleShared = (shareId) => {
  //   setShowPopupShare(true);
  //   setShareId(shareId);
  // };
  
  const onAddWishlist = async () => {
    try {
      const res = await addToWishlist(productCode);
      setIsAddedWishlist(!isAddedWishlist);
      toastMsg(res?.data?.message, res?.data?.details, res?.data?.type);
      //toastMsg("加入我的最愛成功!", null, "default_success_one_line");
    } catch (error) {
      console.error(error);
      toastMsg(
        error?.response?.data?.message,
        error?.response?.data?.details,
        error?.response?.data?.type
      );
    }
  };

  const onRemoveWishlist = async () => {
    try {
      const res = await removeToWishlist(productCode);
      setIsAddedWishlist(!isAddedWishlist);
      toastMsg(res?.data?.message, res?.data?.details, res?.data?.type);
    } catch (error) {
      console.error(error);
      toastMsg(
        error?.response?.data?.message,
        error?.response?.data?.details,
        error?.response?.data?.type
      );
    }
  };

  const openModal = () => {
    setShowModal((prev) => !prev);
  };

  const plpOpenModal = () => setToggle(!toggle);

  const downloadImage = () => {
    saveAs(gallery[currentIndex].url, "productImage.jpg"); // Put your image url here.
  };

  return (
    <>
      <div
        className={`${styles["wrapper"]} product-gallery`}
        id="gallery-wrapper"
      >
        <div className={styles["product-gallery-wrapper"]}>
          <div className={styles["flags-wrapper"]}>
            <ProductFlag productFlags={labels} />
          </div>
          {showIcons && (
            <div className={styles["icons-wrapper"]}>
              {/* {gallery && gallery.length ? ( */}
              <div className={styles["icons"]}>
                {/* Wishlist icon */}
                <div>
                  {isAddedWishlist ? (
                    <img
                      src={Heart}
                      alt=""
                      height="16px"
                      width="18px"
                      onClick={onRemoveWishlist}
                      className={styles["heart"]}
                    />
                  ) : (
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 18 16"
                      fill="black"
                      onClick={onAddWishlist}
                      className={styles["heart"]}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.20586 1.9418C11.1019 0.0115157 14.1636 -0.23877 16.1453 1.42752C18.727 3.60123 18.343 7.13952 16.5087 9.01495L10.495 15.1418C10.1521 15.4915 9.69614 15.6835 9.20586 15.6835C8.719 15.6835 8.25957 15.4881 7.91671 15.1384L1.903 9.01152C0.0652864 7.13609 -0.311856 3.5978 2.26643 1.42752C4.24814 -0.242198 7.30986 0.0115157 9.20586 1.9418ZM9.32243 13.9829L15.3361 7.85609C16.5773 6.59094 16.8379 4.16352 15.0859 2.6858C13.759 1.56809 11.7019 1.72923 10.4059 3.04923L9.20586 4.27323L8.00586 3.04923C6.71671 1.73609 4.65957 1.56809 3.32586 2.68923C1.57043 4.16694 1.82414 6.58066 3.07557 7.85609L9.08929 13.9829C9.17157 14.0652 9.24014 14.0652 9.32243 13.9829Z"
                        fill="#2C2C2C"
                      />
                    </svg>
                  )}
                </div>

                {LoggedInUserRole === UserRoles.ABO ? (
                  <article>
                    {!disableAddToCollection ? (
                      <div>
                        <svg
                          onClick={() =>
                            breakpoint === "xs" ? setOpen(true) : plpOpenModal()
                          }
                          width="16"
                          height="20"
                          className={styles["page"]}
                          viewBox="0 0 16 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.25 0.5C1.01625 0.5 0 1.51625 0 2.75V17.25C0 18.4838 1.01625 19.5 2.25 19.5H8.75C8.93841 19.4994 9.11969 19.4279 9.25781 19.2998L9.25879 19.3008L15.7588 13.3008L15.7578 13.2998C15.8339 13.2298 15.8947 13.1448 15.9364 13.0502C15.978 12.9556 15.9997 12.8534 16 12.75V2.75C16 1.51625 14.9838 0.5 13.75 0.5H2.25ZM2.25 2H13.75C14.1732 2 14.5 2.32675 14.5 2.75V12H10.25C9.01625 12 8 13.0162 8 14.25V18H2.25C1.82675 18 1.5 17.6733 1.5 17.25V2.75C1.5 2.32675 1.82675 2 2.25 2ZM4.75 4.5C4.55109 4.5 4.36032 4.57902 4.21967 4.71967C4.07902 4.86032 4 5.05109 4 5.25C4 5.44891 4.07902 5.63968 4.21967 5.78033C4.36032 5.92098 4.55109 6 4.75 6C4.94891 6 5.13968 5.92098 5.28033 5.78033C5.42098 5.63968 5.5 5.44891 5.5 5.25C5.5 5.05109 5.42098 4.86032 5.28033 4.71967C5.13968 4.57902 4.94891 4.5 4.75 4.5ZM7.25 4.5C7.15062 4.49859 7.05194 4.51696 6.95972 4.55402C6.86749 4.59108 6.78355 4.6461 6.71277 4.71588C6.642 4.78566 6.58579 4.86882 6.54743 4.96051C6.50907 5.0522 6.48932 5.15061 6.48932 5.25C6.48932 5.34939 6.50907 5.4478 6.54743 5.53949C6.58579 5.63118 6.642 5.71434 6.71277 5.78412C6.78355 5.8539 6.86749 5.90892 6.95972 5.94598C7.05194 5.98304 7.15062 6.00141 7.25 6H10.75C10.8494 6.00141 10.9481 5.98304 11.0403 5.94598C11.1325 5.90892 11.2164 5.8539 11.2872 5.78412C11.358 5.71434 11.4142 5.63118 11.4526 5.53949C11.4909 5.4478 11.5107 5.34939 11.5107 5.25C11.5107 5.15061 11.4909 5.0522 11.4526 4.96051C11.4142 4.86882 11.358 4.78566 11.2872 4.71588C11.2164 4.6461 11.1325 4.59108 11.0403 4.55402C10.9481 4.51696 10.8494 4.49859 10.75 4.5H7.25ZM4.75 8C4.55109 8 4.36032 8.07902 4.21967 8.21967C4.07902 8.36032 4 8.55109 4 8.75C4 8.94891 4.07902 9.13968 4.21967 9.28033C4.36032 9.42098 4.55109 9.5 4.75 9.5C4.94891 9.5 5.13968 9.42098 5.28033 9.28033C5.42098 9.13968 5.5 8.94891 5.5 8.75C5.5 8.55109 5.42098 8.36032 5.28033 8.21967C5.13968 8.07902 4.94891 8 4.75 8ZM7.25 8C7.15062 7.99859 7.05194 8.01696 6.95972 8.05402C6.86749 8.09108 6.78355 8.1461 6.71277 8.21588C6.642 8.28566 6.58579 8.36882 6.54743 8.46051C6.50907 8.5522 6.48932 8.65061 6.48932 8.75C6.48932 8.84939 6.50907 8.9478 6.54743 9.03949C6.58579 9.13118 6.642 9.21434 6.71277 9.28412C6.78355 9.3539 6.86749 9.40892 6.95972 9.44598C7.05194 9.48304 7.15062 9.50141 7.25 9.5H10.75C10.8494 9.50141 10.9481 9.48304 11.0403 9.44598C11.1325 9.40892 11.2164 9.3539 11.2872 9.28412C11.358 9.21434 11.4142 9.13118 11.4526 9.03949C11.4909 8.9478 11.5107 8.84939 11.5107 8.75C11.5107 8.65061 11.4909 8.5522 11.4526 8.46051C11.4142 8.36882 11.358 8.28566 11.2872 8.21588C11.2164 8.1461 11.1325 8.09108 11.0403 8.05402C10.9481 8.01696 10.8494 7.99859 10.75 8H7.25ZM10.25 13.5H13.332L9.5 17.0371V14.25C9.5 13.8268 9.82675 13.5 10.25 13.5Z"
                            fill="#212121"
                          />
                        </svg>
                      </div>
                    ) : null}

                    {/* Download icon */}
                    <div onClick={downloadImage}>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        className={styles["download"]}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.25 13.25V15.25C17.25 16.3555 16.3555 17.25 15.25 17.25H2.75C1.64453 17.25 0.75 16.3555 0.75 15.25V13.25"
                          stroke="#2C2C2C"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9 0.75V12.25"
                          stroke="#2C2C2C"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 10.25L9 13.25L6 10.25"
                          stroke="#2C2C2C"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </article>
                )
              //   : LoggedInUserRole !== "Guest" ?
              //   (<div onClick={handleShared}>
              //     <svg 
              //       width="17" 
              //       height="17" 
              //       viewBox="0 0 17 17"
              //       className={styles["share"]} 
              //       fill="none" 
              //       xmlns="http://www.w3.org/2000/svg">
              //     <path 
              //       fillRule="evenodd" 
              //       clipRule="evenodd" 
              //       d="M10.1981 0.0309912C9.92284 0.0160595 9.79268 0.146214 9.80761 0.421456L9.77897 1.36898C9.77763 1.66049 9.91466 1.79751 10.1901 1.78006L14.0529 1.68945L8.31978 7.42257C8.12455 7.6178 8.12366 7.81214 8.3171 8.00559L8.99417 8.68266C9.18762 8.87611 9.38196 8.87522 9.5772 8.67999L15.3103 2.94687L15.2197 6.80972C15.2023 7.08511 15.3393 7.22214 15.6308 7.2208L16.5783 7.19216C16.8536 7.20709 16.9837 7.07693 16.9688 6.80169L16.9982 0.388459C17.0157 0.113069 16.8867 -0.0158972 16.6113 0.0015612L10.1981 0.0309912ZM6.38546 2.34166C6.59436 2.2698 6.72001 2.05068 6.66124 1.83772L6.43152 1.00542C6.37275 0.792469 6.15196 0.66656 5.94217 0.735767C2.6849 1.81028 0.333008 4.87768 0.333008 8.49639C0.333008 13.0087 3.99099 16.6667 8.50335 16.6667C12.3123 16.6667 15.5109 14.0611 16.417 10.5355C16.472 10.3215 16.3316 10.1096 16.1151 10.0653L15.2693 9.8918C15.0529 9.84741 14.8427 9.98751 14.785 10.2008C14.0363 12.9678 11.5067 15.0033 8.50335 15.0033C4.90968 15.0033 1.99643 12.0901 1.99643 8.49639C1.99643 5.64511 3.83101 3.22037 6.38546 2.34166Z" 
              //       fill="#2C2C2C"/>
              //   </svg>
              //  </div>) 
               : null}
              </div>
            </div>
          )}
          <div className={styles["slider-wrapper"]}>
            <ProductSlider
              gallery={gallery}
              onClick={openModal}
              showDots
              showArrows={breakpoint === "xs" ? false : true}
              currentIndex={currentIndex}
              setCurrentIndex={(i) => setCurrentIndex(i)}
              name=""
            />
          </div>
        </div>

        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          gallery={gallery}
          currentIndex={currentIndex}
          setCurrentIndex={(i) => setCurrentIndex(i)}
        />
        <div className={styles["plpModal"]}>
          <PlpModal
            showModal={toggle}
            setShowModal={plpOpenModal}
            productCode={itemCode}
          />
        </div>
        <div className={styles["PlpBottomDrawer"]}>
          <PlpBottomDrawer
            submitButtonWidth={173}
            setOpen={setOpen}
            open={open}
            productCode={itemCode}
          />
        </div>
        <Breakpoint onBreakpointChange={setBreakpoint} />
      </div>
      {/* <ShareBar
       shareInfo={{ type: "products", id: selectedShareId }}
       setShowShareBar={setShowPopupShare}
       showPopup={showPopupShare}
      /> */}
    </>
  );
}

ProductGallery.defaultProps = {
  showIcons: true,
};

export default ProductGallery;
